import { sessionResponseSchema, type SessionResponse } from '@chatapp-inbox/shared';
import { isApiError, request, setCsrfToken } from './http';

/** Entra com e-mail e senha. Guarda o token CSRF da nova sessão para as próximas chamadas. */
export async function login(email: string, password: string): Promise<SessionResponse> {
  const session = await request('/auth/login', {
    method: 'POST',
    body: { email, password },
    schema: sessionResponseSchema,
    auth: 'public',
  });
  setCsrfToken(session.csrfToken);
  return session;
}

/** Sessão atual, ou null se não há ninguém conectado (cookie ausente/expirado). */
export async function fetchSession(signal?: AbortSignal): Promise<SessionResponse | null> {
  try {
    const session = await request('/auth/me', {
      schema: sessionResponseSchema,
      auth: 'public',
      ...(signal ? { signal } : {}),
    });
    setCsrfToken(session.csrfToken);
    return session;
  } catch (err) {
    if (isApiError(err) && err.status === 401) {
      setCsrfToken(null);
      return null;
    }
    throw err;
  }
}

/** Encerra a sessão no servidor. Se ela já tinha acabado (401), o objetivo foi atingido. */
export async function logout(): Promise<void> {
  try {
    await request('/auth/logout', { method: 'POST', auth: 'public' });
  } catch (err) {
    if (!(isApiError(err) && err.status === 401)) throw err;
  }
  setCsrfToken(null);
}
